import { gql } from '@apollo/client';

const CORE_TOOL_ROOM_FIELDS = gql`
  fragment ToolRoomCoreFields on ToolRoom {
    id
    name
    description
    barCode
    latitude
    longitude
    isActive
    thLocationId
    transferEnabled
    adhocEnabled
  }
`;
export const GET_TOOL_ROOM = gql`
  query ToolRooms {
    toolRooms {
      id
      barCode
      description
      latitude
      longitude
      isActive
      name
    }
  }
`;

export const SEARCH_TOOL_ROOM = gql`
  query SearchToolRooms($searchInput: SearchInput) {
    searchToolRooms(searchInput: $searchInput) {
      items {
        id
        barCode
        description
        latitude
        longitude
        isActive
        name
        adhocEnabled
        transferEnabled
        thLocationId
      }
    }
  }
`;

export const SEARCH_PROJECT_CONFIGURATIONS = gql`
  query SearchProjectConfigurations($searchInput: SearchInput) {
    searchProjectConfigurations(searchInput: $searchInput) {
      items {
        id
        updatedBy
        configurationValue
        configurationName
      }
    }
  }
`;
export const SEARCH_USER_TOOL_ROOMS = gql`
  ${CORE_TOOL_ROOM_FIELDS}
  query SearchUserToolRooms($searchInput: SearchInput) {
    searchUserToolRooms(searchInput: $searchInput) {
      items {
        id
        toolRoomId
        toolRoom {
          ...ToolRoomCoreFields
        }
      }
    }
  }
`;
